import React from "react";

function CompaniesIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.25 22.5H13.75H20C20.275 22.5 20.5 22.275 20.5 22V2C20.5 1.725 20.275 1.5 20 1.5H4C3.725 1.5 3.5 1.725 3.5 2V22C3.5 22.275 3.725 22.5 4 22.5H10.25ZM13.25 21.5H10.75V18H13.25V21.5ZM4.5 2.5H19.5V21.5H14.25V17.5C14.25 17.225 14.025 17 13.75 17H10.25C9.975 17 9.75 17.225 9.75 17.5V21.5H4.5V2.5Z"
        fill="#777777"
      />
      <path
        d="M8.5 4H6.5C6.225 4 6 4.225 6 4.5V6.5C6 6.775 6.225 7 6.5 7H8.5C8.775 7 9 6.775 9 6.5V4.5C9 4.225 8.775 4 8.5 4ZM8 6H7V5H8V6ZM11 7H13C13.275 7 13.5 6.775 13.5 6.5V4.5C13.5 4.225 13.275 4 13 4H11C10.725 4 10.5 4.225 10.5 4.5V6.5C10.5 6.775 10.725 7 11 7ZM11.5 5H12.5V6H11.5V5ZM15.5 7H17.5C17.775 7 18 6.775 18 6.5V4.5C18 4.225 17.775 4 17.5 4H15.5C15.225 4 15 4.225 15 4.5V6.5C15 6.775 15.225 7 15.5 7ZM16 5H17V6H16V5ZM8.5 8H6.5C6.225 8 6 8.225 6 8.5V10.5C6 10.775 6.225 11 6.5 11H8.5C8.775 11 9 10.775 9 10.5V8.5C9 8.225 8.775 8 8.5 8ZM8 10H7V9H8V10ZM11 11H13C13.275 11 13.5 10.775 13.5 10.5V8.5C13.5 8.225 13.275 8 13 8H11C10.725 8 10.5 8.225 10.5 8.5V10.5C10.5 10.775 10.725 11 11 11ZM11.5 9H12.5V10H11.5V9ZM15.5 11H17.5C17.775 11 18 10.775 18 10.5V8.5C18 8.225 17.775 8 17.5 8H15.5C15.225 8 15 8.225 15 8.5V10.5C15 10.775 15.225 11 15.5 11ZM16 9H17V10H16V9ZM8.5 12H6.5C6.225 12 6 12.225 6 12.5V14.5C6 14.775 6.225 15 6.5 15H8.5C8.775 15 9 14.775 9 14.5V12.5C9 12.225 8.775 12 8.5 12ZM8 14H7V13H8V14ZM11 15H13C13.275 15 13.5 14.775 13.5 14.5V12.5C13.5 12.225 13.275 12 13 12H11C10.725 12 10.5 12.225 10.5 12.5V14.5C10.5 14.775 10.725 15 11 15ZM11.5 13H12.5V14H11.5V13ZM15.5 15H17.5C17.775 15 18 14.775 18 14.5V12.5C18 12.225 17.775 12 17.5 12H15.5C15.225 12 15 12.225 15 12.5V14.5C15 14.775 15.225 15 15.5 15ZM16 13H17V14H16V13Z"
        fill="#777777"
      />
    </svg>
  );
}

export default CompaniesIcon;
